import { serviceOperationApi } from "./api";

const isExt = (tableName) => tableName === "deposito_destino";
const suffix = (tableName) => (isExt(tableName) ? "Ext" : "");

export async function addTableItem({ item, tableName, accessToken }) {
  const res = await serviceOperationApi.post(
    `/SetData${suffix(tableName)}?table=${tableName}`,
    item,
    { headers: { Authorization: `Bearer ${accessToken}` } },
  );
  return res.status;
}

export async function updateTableItem({ item, tableName, accessToken }) {
  const res = await serviceOperationApi.put(
    `/UpdateData${suffix(tableName)}?table=${tableName}`,
    item,
    { headers: { Authorization: `Bearer ${accessToken}` } },
  );
  return res.status;
}

export async function deleteTableItem({ item, tableName, accessToken }) {
  const res = await serviceOperationApi.delete(
    `/DeleteData${suffix(tableName)}?table=${tableName}&id=${item.id}`,
    { headers: { Authorization: `Bearer ${accessToken}` } },
  );
  return res.status;
}
